import { render, staticRenderFns } from "./DynamicCardList.vue?vue&type=template&id=87557af6&"
import script from "./DynamicCardList.vue?vue&type=script&lang=js&"
export * from "./DynamicCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports